import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../components/Button';
import Tabs from '../../../components/Tabs/Tabs';
import { Container } from 'react-bootstrap';
import Summary from './Summary';
import FullDescription from './FullDescription';
import ModalHeader from '../../../components/ModalHeader';

const tabsData = [
  {
    name: 'Summary',
    content: <Summary />,
  },
  {
    name: 'Full Description ',
    content: <FullDescription />,
  },
];

export type PensionElectionChecklistModalProps = {
  showPensionElectionChecklistModal: boolean;
  handleHidePensionElectionChecklistModal: () => void;
};

function PensionElectionChecklistModal({
  showPensionElectionChecklistModal,
  handleHidePensionElectionChecklistModal,
}: PensionElectionChecklistModalProps) {
  return (
    <>
      <Modal
        show={showPensionElectionChecklistModal}
        onHide={handleHidePensionElectionChecklistModal}
        dialogClassName="pension-election-checklist-modal pl-0"
        size={'xl'}
      >
        <ModalHeader className={'border-0'} closeButton>
          <h4 className="ps-lg-5 text-sm-20-lg-32">
            Pension Election Checklist
          </h4>
        </ModalHeader>

        <Modal.Body className={'px-7 px-lg-12'}>
          <Container className={'px-0'}>
            <Tabs variant={'horizontal'} tabs={tabsData}></Tabs>
          </Container>
        </Modal.Body>
        <Modal.Footer className={'justify-content-center align-items-start'}>
          <Button
            className="d-none d-lg-block"
            onClick={handleHidePensionElectionChecklistModal}
            variant={'primary-outline'}
          >
            Close
          </Button>

          <a href={`${process.env.PUBLIC_URL}/${'interlink-pension-checklist.pdf'}`} target={'_blank'} rel="noreferrer">
            <Button
              onClick={() => console.log('Download/Print')}
              variant="primary"
              rightIcon={light('file-arrow-down')}
            >
              Download/Print
            </Button>
          </a>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PensionElectionChecklistModal;
